import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import CancelamentoPage from './cancelamento.page';
import * as actions from '../../material.action';
import * as commonActions from '@common/common.action';
import CommonFunctions from '@common/util/functions.common';
import WebapiCommon from '@common/util/webapi.common';
import { statusEtapasEnum, etapasEnum } from '@common/util/defaultValues';

class CancelamentoContainer extends Component {
	constructor() {
		super();
		this.state = {
			habilitaCancelamento: false,
			showModalCancelamento: false,
			disableButton: false,
			justificativa: '',
			existeBlocoAndLamina: false,
			cancelarBlocoAndLaminas: false,
			blocosExistentes: [],
			laminasExistentes: [],
			showModalConfirmarCancelamento: false,
		};
	}

	componentDidMount() {
		this._habilitaCancelamento();
	}

	componentDidUpdate() {
		//this._habilitaCancelamento();
	}

	render() {
		const {
			existeBlocoAndLamina,
			cancelarBlocoAndLaminas,
			blocosExistentes,
			laminasExistentes,
		} = this.state;

		let labelChekboxCancelarBlocoAndLaminas = 'Existem';
		labelChekboxCancelarBlocoAndLaminas +=
			blocosExistentes.length > 0 ? ' blocos' : '';
		labelChekboxCancelarBlocoAndLaminas +=
			laminasExistentes.length > 0
				? blocosExistentes.length > 0
					? ' e lâminas'
					: ' lâminas'
				: '';

		labelChekboxCancelarBlocoAndLaminas +=
			' cadastrados para esse exame. Deseja cancelar assim mesmo?';

		return (
			<CancelamentoPage
				showModalCancelamento={this.state.showModalCancelamento}
				disableCancelamento={this.state.habilitaCancelamento}
				justificativa={this.state.justificativa}
				disableButton={this.state.disableButton}
				onClickCancelamento={this.onClickCancelamento.bind(this)}
				toggleModalCancelamento={this.toggleModalCancelamento.bind(this)}
				setJustificativa={this.setJustificativa.bind(this)}
				existeBlocoAndLamina={existeBlocoAndLamina}
				cancelarBlocoAndLaminas={cancelarBlocoAndLaminas}
				onChangeCheckboxCancelarBlocosAndLaminas={this.onChangeCheckboxCancelarBlocosAndLaminas.bind(
					this
				)}
				blocosExistentes={blocosExistentes}
				laminasExistentes={laminasExistentes}
				labelChekboxCancelarBlocoAndLaminas={
					labelChekboxCancelarBlocoAndLaminas
				}
				showModalConfirmarCancelamento={this.confirmarCancelamentoEtapas.bind(
					this
				)}
				toggleModalConfirmarCancelamento={this.toggleModalConfirmarCancelamento.bind(
					this
				)}
				showModal={this.state.showModalConfirmarCancelamento}
				cancelarEtapasPosteriores={this.cancelarEtapasPosteriores.bind(this)}
			/>
		);
	}

	toggleModalCancelamento() {
		this.setState((state) => ({
			showModalCancelamento: !state.showModalCancelamento,
		}));
	}

	setJustificativa(text) {
		this.setState({
			justificativa: text,
		});
	}

	onClickCancelamento() {
		if (!this.state.habilitaCancelamento) {
			this.props.actions.showAlerta(
				'alerta',
				'Não é possivel realizar o cancelamento!',
				1500
			);
		} else {
			this.props.commonActions.showFadeCarregando(true);
			CommonFunctions.cancelarRecebimentoMaterial(
				this.props.detalhes,
				this.props.listagem,
				this.props.commonActions,
				this.state.justificativa,
				this.state.cancelarBlocoAndLaminas
			).then((response) => {
				let tipo = response.data.cancelado ? 'sucesso' : 'erro';
				let mensagem = response.data.mensagem;
				this.props.commonActions.showFadeCarregando(false);

				if (!response.data.cancelado && response.data.existeBlocoAndLamina) {
					this.setState({
						existeBlocoAndLamina: true,
						blocosExistentes: response.data.existeBlocoAndLamina.blocos,
						laminasExistentes: response.data.existeBlocoAndLamina.laminas,
					});
				} else {
					let larguraAlerta = mensagem.length * 10 + 'px';

					this.props.commonActions.showAlerta(
						tipo,
						mensagem,
						3000,
						larguraAlerta
					);

					if (response.data.cancelado) {
						let laudo = this.props.detalhes.laudo;
						this.props.commonActions.atualizarNumeroExameDoLaudoNaListagem(
							laudo,
							''
						);
						this.props.commonActions.atualizarPropriedadeNoItemDaLista(
							laudo,
							'laudoAnterior',
							0
						);
						this.props.commonActions.atualizarPropriedadeNoItemDaLista(
							laudo,
							'numeroExameAnterior',
							''
						);

						WebapiCommon.obterStatusEtapasLaudo(laudo)
							.then((etapas) => {
								this.props.commonActions.atualizarStatusDasEtapasDoLaudo(
									etapas,
									laudo
								);
								CommonFunctions.fecharExameEtapaRecebimento(this.props);
							})
							.catch(() => this.props.history.goBack());
					} else {
						if (response.data.existeNConformidadePendente) {
							let tabNConformidade = '2';
							this.props.actions.mudarTabAtiva(tabNConformidade);
						}

						this.setState((state) => ({
							showModalCancelamento: !state.showModalCancelamento,
							justificativa: '',
						}));
					}
				}
			});
		}
	}

	cancelarEtapasPosteriores() {
		this.props.commonActions.showFadeCarregando(true);
		WebapiCommon.cancelarEtapasPosteriores(
			this.props.detalhes.laudo,
			this.props.etapaAtual,
			0,
			this.state.justificativa
		)
			.then((resp) => {
				if (resp.success) {
					this.props.commonActions.showAlerta(
						'sucesso',
						resp.data.mensagem,
						2000
					);

					WebapiCommon.obterStatusEtapasLaudo(this.props.detalhes.laudo).then(
						(etapas) => {
							this.props.commonActions.atualizarStatusDasEtapasDoLaudo(
								etapas,
								this.props.detalhes.laudo
							);
							this.props.commonActions.showEditor(false);
							this.props.commonActions.showFadeCarregando(false);
							this.toggleModalCancelamento();
							this.toggleModalConfirmarCancelamento();
							this.props.history.goBack();
						}
					);
				} else {
					this.props.commonActions.showFadeCarregando(false);
					this.props.commonActions.showAlerta();
					this.toggleModalCancelamento();
					this.toggleModalConfirmarCancelamento();
				}
			})
			.catch((error) => {
				this.props.commonActions.showFadeCarregando(false);
				this.toggleModalCancelamento();
				this.toggleModalConfirmarCancelamento();
			});
	}

	_habilitaCancelamento() {
		let etapas = this.props.detalhes.etapas;

		let concluidas = etapas.filter((item) => {
			return item.status === statusEtapasEnum.REALIZADO;
		});

		let material = etapas.find((item) => {
			return item.etapa === etapasEnum.MATERIAL;
		});

		let etapasNaoPermitidas = concluidas.filter((el) => {
			return el.etapa !== etapasEnum.MATERIAL && el.etapa !== etapasEnum.MACRO;
		});

		return this.setState({
			habilitaCancelamento: true,
			disableButton: material.status === statusEtapasEnum.NAO_REALIZADO,
		});

		// eslint-disable-next-line no-unreachable
		if (
			this.state.habilitaCancelamento !==
			(etapasNaoPermitidas.length === 0)
		) {
			this.setState({
				habilitaCancelamento: etapasNaoPermitidas.length === 0,
				disableButton: material.status === statusEtapasEnum.NAO_REALIZADO,
			});
		}
	}

	confirmarCancelamentoEtapas() {
		this.setState({
			showModalConfirmarCancelamento: true,
		});
	}

	toggleModalConfirmarCancelamento() {
		this.setState({
			showModalConfirmarCancelamento: false,
		});
	}

	onChangeCheckboxCancelarBlocosAndLaminas() {
		this.setState((state) => ({
			cancelarBlocoAndLaminas: !state.cancelarBlocoAndLaminas,
		}));
	}
}

const mapStateToProps = (state) => {
	return {
		detalhes: state.commonReducer.detalhes,
		listagem: state.commonReducer.listagem,
		etapaAtual: state.commonReducer.etapa.etapa,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		actions: bindActionCreators(actions, dispatch),
		commonActions: bindActionCreators(commonActions, dispatch),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(CancelamentoContainer);



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/material/tabs/cancelamento/cancelamento.container.js